import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAccountsBasedOnSite(
  oauthTokenHeader: string,
  queryId: string,
  site_shared_uid: string,
  account_traffic_source_shared_uid: string | any,
  account_isactive: number | any
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?site_shared_uid=${site_shared_uid}&account_traffic_source_shared_uid=${account_traffic_source_shared_uid}&account_isactive=${account_isactive}`,
    oauthTokenHeader
  );
}

function getAllScopes(oauthTokenHeader: string, website_shared_uid: string, account_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader
  );
}

function getCampaignsWithoutScope(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader
  );
}

function getNegativeDefinitionBothListAndAdgroup(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader
  );
}

function getNegativeDefinitionInCampaign(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader
  );
}

function createNewScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/scope/`,
    data,
    oauthTokenHeader
  );
}

function editScope(oauthTokenHeader: string, data: any, scope_shared_uid: any) {
  return fetchWrapper.patch(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/scope/${scope_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function linkBetweenCampaignToScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/campaign_to_scope/`,
    data,
    oauthTokenHeader
  );
}

function unlinkCampaigsFromScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.patch(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/unlink/`,
    data,
    oauthTokenHeader
  );
}

function removeNegativeTerms(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/negative_terms/remove`,
    data,
    oauthTokenHeader
  );
}

export const stOperationService = {
  getAccountsBasedOnSite,
  getAllScopes,
  getCampaignsWithoutScope,
  getNegativeDefinitionBothListAndAdgroup,
  getNegativeDefinitionInCampaign,
  createNewScope,
  linkBetweenCampaignToScope,
  removeNegativeTerms,
  editScope,
  unlinkCampaigsFromScope
};
